"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var fields_path_service_1 = require("./fields-path-service");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var Observable_1 = require("rxjs/Observable");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var core_1 = require("@angular/core");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var operators_1 = require("rxjs/operators");
require("rxjs/add/operator/switchMap");
var HttpFieldsPathService = /** @class */ (function (_super) {
    __extends(HttpFieldsPathService, _super);
    function HttpFieldsPathService(http, applicationPropertiesService, currentLanguageProvider) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.applicationPropertiesService = applicationPropertiesService;
        _this.currentLanguageProvider = currentLanguageProvider;
        _this.fetchLanguageId();
        _this.serviceUrlHolder = _this.getServiceUrl().pipe(operators_1.shareReplay(1));
        return _this;
    }
    HttpFieldsPathService_1 = HttpFieldsPathService;
    HttpFieldsPathService.prototype.getAllIncomingFields = function (category) {
        return this.getFieldsWithInclude(category, 'incoming');
    };
    HttpFieldsPathService.prototype.getAllOutgoingFields = function (category) {
        return this.getFieldsWithInclude(category, 'standard,outgoing');
    };
    HttpFieldsPathService.prototype.getIncomingFields = function (category) {
        return this.getFieldsWithInclude(category, 'incoming');
    };
    HttpFieldsPathService.prototype.getOutgoingFields = function (category) {
        return this.getFieldsWithInclude(category, 'outgoing');
    };
    HttpFieldsPathService.prototype.getFields = function (fieldExpression) {
        var _this = this;
        return this.getServiceUrl().switchMap(function (serviceUrl) {
            var url = HttpFieldsPathService_1.FIELDS_EXPRESSION_PATH.replaceTemplate({
                serviceUrl: serviceUrl,
                languageId: _this.languageId.toString()
            });
            return _this.http.post(url, fieldExpression);
        });
    };
    HttpFieldsPathService.prototype.fetchLanguageId = function () {
        var _this = this;
        this.currentLanguageProvider
            .getCurrentLanguage()
            .pipe(operators_1.shareReplay(1))
            .subscribe(function (language) {
            _this.languageId = language.getId();
        });
    };
    HttpFieldsPathService.prototype.getFieldsWithInclude = function (category, include) {
        var _this = this;
        return this.serviceUrlHolder.switchMap(function (serviceUrl) {
            var url = HttpFieldsPathService_1.FIELDS_PATH.replaceTemplate({
                serviceUrl: serviceUrl,
                category: category,
                include: include,
                languageId: _this.languageId.toString()
            });
            return _this.http.get(url);
        });
    };
    HttpFieldsPathService.prototype.getServiceUrl = function () {
        var _this = this;
        return Observable_1.Observable.from(this.applicationPropertiesService.getProperty('fe2-service-url')).switchMap(function (url) {
            if (url) {
                return Observable_1.Observable.of(url);
            }
            return Observable_1.Observable.from(_this.applicationPropertiesService.getProperty('event-handler-service-url'));
        });
    };
    HttpFieldsPathService.FIELDS_PATH = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/fields/", "?languageId=", "&include=", ""], ["", "/fields/", "?languageId=", "&include=", ""])), 'serviceUrl', 'category', 'languageId', 'include');
    HttpFieldsPathService.FIELDS_EXPRESSION_PATH = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "/fields?languageId=", ""], ["", "/fields?languageId=", ""])), 'serviceUrl', 'languageId');
    HttpFieldsPathService = HttpFieldsPathService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], HttpFieldsPathService);
    return HttpFieldsPathService;
    var HttpFieldsPathService_1;
}(fields_path_service_1.FieldsPathService));
exports.HttpFieldsPathService = HttpFieldsPathService;
var templateObject_1, templateObject_2;
//# sourceMappingURL=http-fields-path-service.js.map